<template>
  <layout-main-inner title="全部订单">
    <layout-card-wrap :hasHeaderSlot="true">
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item
          label="下单日期:"
          style="margin-bottom: 0">
          <el-date-picker
            v-model="time"
            unlink-panels
            style="width:220px"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleCurrentChange(1)">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <!-- <el-radio-group
            v-model="status"
            @change="fetchList">
            <el-radio-button label="$">全部</el-radio-button>
            <el-radio-button label="2$2">待支付</el-radio-button>
            <el-radio-button label="3$3">待发货</el-radio-button>
            <el-radio-button label="4$8">已发货</el-radio-button>
            <el-radio-button label="9$">已完成</el-radio-button>
          </el-radio-group> -->
          <el-select
            v-model="status"
            style="width: 100px"
            placeholder="请选择"
            @change="handleCurrentChange(1)">
            <el-option
              label="全部"
              value="$">
            </el-option>
            <el-option
              label="待支付"
              value="2$2">
            </el-option>
            <el-option
              label="待发货"
              value="3$3">
            </el-option>
            <el-option
              label="已发货"
              value="4$8">
            </el-option>
            <el-option
              label="已完成"
              value="9$">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-input
            v-model.trim="config.orderNumber"
            placeholder="请输入订单编号"
            style="width:200px"
            clearable></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button
            type="primary"
            @click="handleCurrentChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <!-- <el-table-column type="expand">
          <template slot-scope="{row}">
            <order-goods-info
              :orderType="row.orderType"
              :orderItems="row.orderItems" />
          </template>
        </el-table-column> -->
        <el-table-column
          label="订单编号"
          fixed="left"
          :resizable="false"
          width="200">
          <template slot-scope="{row}">
            <link-route :link-to="`/wxapp-order-detail?orderId=${row.orderId}&vendorId=${row.vendorId}&orderNumber=${row.orderNumber}`">
              {{ row.orderNumber }}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="下单人"
          prop="mobilePhone"
          width="110">
        </el-table-column>
        <el-table-column
          label="收件人"
          min-width="140"
          :resizable="false">
          <template slot-scope="{row}">
            <span>{{ row.deliveryName }}-{{ row.deliveryPhone }}</span>
            <!-- <div>联系人：{{ row.deliveryName }}</div>
            <div>联系方式：<span style="color:#409eff">{{ row.deliveryPhone }}</span></div>
            <div>地址：{{ row.provinceName || '未知' }}-{{ row.cityName || '未知' }}-{{ row.areaName || '未知' }}-{{ row.detailedAddress || '未知' }}</div> -->
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="订单金额"
          width="70">
          <template slot-scope="{row}">
            <span>¥{{ row.payAmount }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="物流信息"
          :resizable="false">
          <template slot-scope="{row}">
            <span v-if="row.expressId">{{ row.expressName }}({{ row.courierNumber }})</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="订单状态"
          :resizable="false"
          min-width="140"
          prop="orderStatusName">
          <template slot-scope="{row}">
            {{ row.orderStatusName }}
            <el-tag
              v-if="row.orderReturnStatus!==0"
              style="margin-left:5px;"
              type="danger"> {{ row.orderReturnStatusName }}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="购买人信息">
          <template slot-scope="{row}">
            <div>联系人：{{ row.userName }}</div>
            <div>联系方式：<span style="color:#409eff">{{ row.mobilePhone }}</span></div>
          </template>
        </el-table-column> -->
        <el-table-column
          :resizable="false"
          label="备注信息"
          min-width="160"
          prop="remarks">
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="下单时间"
          width="140">
          <template slot-scope="{row}">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="支付时间"
          width="140">
          <template slot-scope="{row}">
            <span>{{ row.payTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :width="buildMode !== 'SH_WEB' ? 130 : 80">
          <template slot-scope="{row}">
            <template v-if="buildMode !== 'SH_WEB'">
              <el-button
                type="text"
                :disabled="!((row.orderStatus === 3) && row.orderReturnStatus === 0)"
                @click="deliverorder(row)">
                发货
              </el-button>
            </template>
            <el-button
              type="text"
              :disabled="!((row.orderStatus > 5 && row.orderStatus < 9) && row.orderReturnStatus === 0)"
              @click="closeorder(row)">
              完成订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import OrderGoodsInfo from './busi/order-goods-info.vue'
import moment from 'moment'
export default {
  name: 'WxappOrderIndex',
  components: { },
  data() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    return {
      buildMode: process.env.VUE_APP_BUILD_MODE,
      loading: false,
      list: [],
      total: 0,
      status: '$',
      time: [start, end],
      config: {
        pageNum: 1,
        pageSize: 10,
        orderNumber: '',
        minStatus: null,
        maxStatus: null,
        orderType: 1,
        createBeginDate: null,
        createEndDate: null
      },
      orderType: {
        1: '现金',
        2: '积分',
        3: '奖品'
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    deliverorder(row) {
      this.$prompt('请输入物流单号发货', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /\S/, inputErrorMessage: '请输入物流单号',
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            const courierNumber = instance.inputValue
            this.$store.dispatch('order/deliverorder', {
              payload: { courierNumber, vendorId: row.vendorId, orderId: row.orderId },
              success: (res) => {
                console.log(res)
                this.loading = false
                done()
                this.fetchList()
              },
              fail: () => {
                this.loading = false
              }
            })
          }
        }
      })
    },
    closeorder(row) {
      console.log(row)
      this.$confirm('您确定手动完成该订单?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('order/closeorder', {
            payload: { vendorId: row.vendorId, orderId: row.orderId },
            success: (res) => {
              console.log(res)
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    detaili(data) {
      this.$router.push(`/ordersdetail?orderId=${data.orderId}&vendorId=${data.vendorId}`)
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const status = this.status.split('$')
      const time = this.time || []
      this.$store.dispatch('order/getorders', {
        payload: {
          ...this.config,
          minStatus: +status[0] || null,
          maxStatus: +status[1] || null,
          createBeginDate: +time[0] ? +moment(+time[0]).startOf('days') : null,
          createEndDate: +time[1] ? +moment(+time[1]).endOf('days') : null,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
